import type { RegistryEntry } from "../../shared.ts";

export const command_codeProvider: RegistryEntry = {
  id: "command-code",
  alias: "cmd",
  format: "openai",
  executor: "command-code",
  baseUrl: "https://api.commandcode.ai",
  chatPath: "/alpha/generate",
  modelsUrl: "https://api.commandcode.ai/provider/v1/models",
  authType: "apikey",
  authHeader: "Authorization",
  authPrefix: "Bearer ",
  defaultContextLength: 200000,
  models: [
    {
      id: "claude-opus-4-7",
      name: "Claude Opus 4.7 (CC)",
      supportsReasoning: true,
      contextLength: 200000,
      maxOutputTokens: 32000,
    },
    {
      id: "claude-opus-4-6",
      name: "Claude Opus 4.6 (CC)",
      supportsReasoning: true,
      contextLength: 200000,
      maxOutputTokens: 32000,
    },
    {
      id: "claude-sonnet-4-6",
      name: "Claude Sonnet 4.6 (CC)",
      supportsReasoning: true,
      contextLength: 200000,
      maxOutputTokens: 16384,
    },
    {
      id: "claude-haiku-4-5-20251001",
      name: "Claude Haiku 4.5 (CC)",
      supportsReasoning: true,
      contextLength: 200000,
      maxOutputTokens: 8192,
    },
    {
      id: "gpt-5.5",
      name: "GPT-5.5 (CC)",
      supportsReasoning: true,
      contextLength: 256000,
      maxOutputTokens: 128000,
    },
    {
      id: "gpt-5.4",
      name: "GPT-5.4 (CC)",
      supportsReasoning: true,
      contextLength: 256000,
      maxOutputTokens: 128000,
    },
    {
      id: "gpt-5.3-codex",
      name: "GPT-5.3 Codex (CC)",
      supportsReasoning: true,
      contextLength: 256000,
      maxOutputTokens: 128000,
    },
    {
      id: "gpt-5.4-mini",
      name: "GPT-5.4 Mini (CC)",
      supportsReasoning: false,
      contextLength: 256000,
      maxOutputTokens: 128000,
    },
    {
      id: "deepseek/deepseek-v4-pro",
      name: "DeepSeek V4 Pro (CC)",
      supportsReasoning: true,
      contextLength: 1000000,
      maxOutputTokens: 131072,
    },
    {
      id: "deepseek/deepseek-v4-flash",
      name: "DeepSeek V4 Flash (CC)",
      supportsReasoning: true,
      contextLength: 1000000,
      maxOutputTokens: 131072,
    },
    {
      id: "moonshotai/Kimi-K2.6",
      name: "Kimi K2.6 (CC)",
      supportsReasoning: true,
      contextLength: 262144,
      maxOutputTokens: 65536,
    },
    {
      id: "moonshotai/Kimi-K2.5",
      name: "Kimi K2.5 (CC)",
      supportsReasoning: true,
      contextLength: 262144,
      maxOutputTokens: 65536,
    },
    {
      id: "zai-org/GLM-5.1",
      name: "GLM-5.1 (CC)",
      supportsReasoning: true,
      contextLength: 200000,
      maxOutputTokens: 32768,
    },
    {
      id: "zai-org/GLM-5",
      name: "GLM-5 (CC)",
      supportsReasoning: true,
      contextLength: 200000,
      maxOutputTokens: 32768,
    },
    {
      id: "MiniMaxAI/MiniMax-M2.7",
      name: "MiniMax M2.7 (CC)",
      supportsReasoning: true,
      contextLength: 1048576,
      maxOutputTokens: 65536,
    },
    {
      id: "MiniMaxAI/MiniMax-M2.5",
      name: "MiniMax M2.5 (CC)",
      supportsReasoning: true,
      contextLength: 1048576,
      maxOutputTokens: 65536,
    },
    {
      id: "Qwen/Qwen3.6-Max-Preview",
      name: "Qwen 3.6 Max (CC)",
      supportsReasoning: true,
      contextLength: 1000000,
      maxOutputTokens: 32768,
    },
    {
      id: "Qwen/Qwen3.6-Plus",
      name: "Qwen 3.6 Plus (CC)",
      supportsReasoning: true,
      contextLength: 1000000,
      maxOutputTokens: 32768,
    },
  ],
};
